<script>
import { mapGetters } from 'vuex'
import CancelButtonMixin from '@/components-v4/cancel-button/cancel-button-mixin'
import CancelButton from '@/components-v4/cancel-button/index.vue'

export default {
  name: 'TamaraHeader',
  components: { CancelButton },
  mixins: [CancelButtonMixin],
  props: {
    hideCancelButton: Proptypes.boolean(false),
    displayBackButton: Proptypes.boolean(false),
    disabledBackButton: Proptypes.boolean(false),
    disabledCancelButton: Proptypes.boolean(false),
    stage: Proptypes.string(''),
  },
  computed: {
    ...mapGetters('application', ['isArabic', 'isRightToLeftDirection']),
    ...mapGetters('session', { orderSession: 'order' }),
    merchantLogo() {
      return this.orderSession.merchantLogo
    },
    merchantName() {
      return this.orderSession.merchantName
    },
    tamaraLogo() {
      if (this.isArabic) {
        return 'tamara-logo-text-ar'
      }

      return 'tamara-logo-text-en'
    },
    iconName() {
      return this.$options.filters.displayChevronIconByDirection(
        this.isRightToLeftDirection
      )
    },
  },
  methods: {
    reloadIframe() {
      location.reload()
      return false
    },
  },
}
</script>

<template>
  <v-card
    width="100%"
    color="transparent"
    class="mx-auto tamara-base-header"
    elevation="0"
  >
    <div class="mx-auto tamara-base-header__wrapper">
      <v-card
        class="d-flex align-center"
        elevation="0"
        width="100%"
        max-width="100%"
        color="transparent"
      >
        <v-btn
          v-if="displayBackButton"
          fab
          small
          class="flex-grow-0 flex-shrink-0 me-3"
          color="white"
          elevation="0"
          :disabled="disabledBackButton"
          @click="$emit('on-back', $event)"
        >
          <SvgIcon :name="iconName" />
        </v-btn>
        <div
          v-if="merchantLogo && !displayBackButton"
          class="me-3 merchant-icon__wrapper"
        >
          <v-img
            class="merchant-icon"
            contain
            :src="merchantLogo"
            width="100%"
            height="100%"
          />
        </div>
        <v-card
          class="overflow-hidden flex-grow-1 flex-shrink-1 tamara-base-header__content pe-2"
          elevation="0"
          color="transparent"
          style="padding-top: 6px; padding-bottom: 6px"
        >
          <h3 class="text-truncate font-primary">
            {{ merchantName }}
          </h3>
          <div
            class="font-secondary tamara-subtitle-2 primary--text d-flex align-center"
          >
            {{ $t('checkout_header_text') }}
            <SvgIcon
              :name="tamaraLogo"
              width="78px"
              height="32px"
              class="tamara-base-header_logo-tamata ms-1"
            />
          </div>
        </v-card>
        <CancelButton
          v-if="!hideCancelButton && cancelUrl"
          :disabled="disabledCancelButton"
        >
          <v-btn
            fab
            small
            class="flex-grow-0 flex-shrink-0"
            color="white"
            elevation="0"
          >
            <SvgIcon name="window-close" />
          </v-btn>
        </CancelButton>
      </v-card>
    </div>
  </v-card>
</template>

<style lang="scss" scope>
@import '@/styles/responsive.scss';

.tamara-base-header {
  width: 100%;
  min-width: 100%;
  position: relative;
  z-index: 199 !important;
  padding-top: 8px;

  &__wrapper {
    max-height: 56px;
    max-width: 474px;
    width: 100%;
    padding: 0 24px;
  }

  &__content {
    padding-top: 6px;
    padding-bottom: 6px;
    box-sizing: border-box;
    height: 56px;
  }

  .merchant-icon__wrapper {
    width: 44px;
    height: 44px;
    border-radius: 50% !important;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 0 0 44px;
  }

  .merchant-icon {
    max-width: 100%;
    max-height: 100%;
    border-radius: 50% !important;
    overflow: hidden;
  }

  &_logo-tamata {
    svg {
      font-size: 24px;
      width: 44px;
      height: 24px;
    }
  }
}

@include for-md-up {
  .tamara-base-header {
    padding-top: 56px;

    .merchant-icon__wrapper {
      width: 52px;
      height: 52px;
      flex: 0 0 52px;
    }
  }
}
</style>
